import { render, staticRenderFns } from "./DunningLetters.yaml?vue&type=template&id=59c87cef&component"
import script from "./DunningLetters.yaml?vue&type=script&lang=ts&component"
export * from "./DunningLetters.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports